import FormattedMessage from 'I18n/components/FormattedMessage';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { DashboardPage } from 'foundations-components/transitional/components/DashboardPage';
import { usePublishedCollections } from 'marketplace-ui-common/collections/hooks/usePublishedCollections';
import LoadingWrapper from 'marketplace-ui-common/layout/components/LoadingWrapper';
import { UsageScreenProvider } from 'marketplace-ui-tracking';
import { NavMarker } from 'react-rhumb';
import { StorefrontCollectionCard } from '../components/cards/StorefrontCollectionCard';
import { BaseHeader } from '../components/headers/BaseHeader';
import { Screens } from '../constants/usage';
import { useAppContext } from '../context/AppContext';
import { jsx as _jsx } from "react/jsx-runtime";
export function Featured() {
  const appContext = useAppContext();
  const {
    getDisplayedCollections,
    requestState: publishedAppCollectionsRequestState
  } = usePublishedCollections({
    appContext: appContext,
    offeringType: 'APP'
  });
  const collections = getDisplayedCollections();
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "FEATURED_LOAD",
    children: /*#__PURE__*/_jsx(UsageScreenProvider, {
      screen: Screens.FEATURED,
      children: /*#__PURE__*/_jsx(DashboardPage, {
        headerComponent: /*#__PURE__*/_jsx(BaseHeader, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceStorefront.featured.title"
          }),
          pathKey: "FEATURED",
          dataTestId: "featured-page-header"
        }),
        children: /*#__PURE__*/_jsx(LoadingWrapper, {
          requestStatus: publishedAppCollectionsRequestState,
          children: /*#__PURE__*/_jsx(CardGrid, {
            "data-test-id": "featured-grid",
            columns: 2,
            gap: "400",
            children: collections.map(collection => {
              var _collection$published, _collection$published2, _collection$published3;
              return /*#__PURE__*/_jsx(StorefrontCollectionCard, {
                description: ((_collection$published = collection.publishedListing) === null || _collection$published === void 0 ? void 0 : _collection$published.metaDescription) || '',
                imageSrc: "",
                name: ((_collection$published2 = collection.publishedListing) === null || _collection$published2 === void 0 ? void 0 : _collection$published2.name) || collection.internalName,
                slug: ((_collection$published3 = collection.publishedListing) === null || _collection$published3 === void 0 ? void 0 : _collection$published3.slug) || '',
                use: "on-dark"
              }, collection.internalName);
            })
          })
        })
      })
    })
  });
}